import { SchemaProvider } from "@/v2/hooks/SchemaContext";
import type { ComponentProps, ReactNode } from "react";
import {
    FormProvider,
    type FieldValues,
    type SubmitHandler,
    type UseFormReturn,
} from "react-hook-form";
import z from "zod";

type FormBaseProps = ComponentProps<"form">;

interface ArFormProps<T extends FieldValues> extends Omit<
    FormBaseProps,
    "onSubmit"
> {
    form: UseFormReturn<T>;
    children: ReactNode;
    onSubmit: SubmitHandler<T>;
    formSchema: z.ZodObject<any>;
}

export function ArForm<T extends FieldValues>({
    children,
    form,
    onSubmit,
    formSchema,
    ...rest
}: ArFormProps<T>) {
    return (
        <SchemaProvider schema={formSchema}>
            <FormProvider {...form}>
                <form
                    className="z-30 max-h-[80vh] overflow-y-scroll px-4 pb-8"
                    onSubmit={form.handleSubmit(onSubmit)}
                    {...rest}
                >
                    {children}
                </form>
            </FormProvider>
        </SchemaProvider>
    );
}
